"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadDataDialog = void 0;
const react_1 = __importStar(require("react"));
const update_catalog_option_1 = require("./update-catalog-option");
const upload_box_1 = require("./upload-box");
const upload_data_dialog_constants_1 = require("./upload-data-dialog.constants");
const upload_data_dialog_styles_1 = require("./upload-data-dialog.styles");
const components_1 = require("../components");
const generic_1 = require("../generic");
const hooks_1 = require("../hooks");
const upload_file_options_1 = require("../models/upload-file-options");
const feature_flags_1 = require("../../feature-flags");
const hooks_2 = require("../../hooks");
const localization_1 = require("../../localization");
const UploadDataDialog = ({ isDisabled, isFileUploading, fileUploadError, onClose, onCatalogUpdate, onCatalogCreate, onEnrichedDataUpdate, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { featureFlagsService } = (0, hooks_2.useFeatureFlagsService)();
    const isCreateCatalogEnabled = featureFlagsService
        .isFeatureEnabled(feature_flags_1.FeatureFlag.CreateCatalog);
    const [fileToUpload, setFileToUpload] = (0, react_1.useState)();
    const [updateDataType, setUpdateDataType] = (0, react_1.useState)(upload_file_options_1.UpdateCatalogTypes.Catalog);
    const [updateDataMode, setUpdateDataMode] = (0, react_1.useState)(upload_file_options_1.UpdateDataModes.Merge);
    const modeOptions = (0, react_1.useMemo)(() => [upload_file_options_1.UpdateDataModes.Replace, upload_file_options_1.UpdateDataModes.Merge], []);
    const { parseFile, reset, data, columnsOrder, errors, } = (0, hooks_1.useCSVParser)({
        columnIdIndex: 0,
    });
    const handleOptionChange = (option) => setUpdateDataMode(option);
    const handleSubmit = () => {
        if (updateDataType === upload_file_options_1.UpdateCatalogTypes.CreateCatalog) {
            onCatalogCreate(fileToUpload);
        }
        else if (updateDataType === upload_file_options_1.UpdateCatalogTypes.Catalog) {
            onCatalogUpdate(fileToUpload, updateDataMode);
        }
        else {
            onEnrichedDataUpdate(data, columnsOrder, updateDataMode);
        }
    };
    (0, react_1.useEffect)(() => {
        if (fileToUpload) {
            reset();
            if (updateDataType === upload_file_options_1.UpdateCatalogTypes.Data) {
                parseFile(fileToUpload.file);
            }
        }
    }, [fileToUpload, parseFile, reset, updateDataType]);
    const errorMessage = (0, react_1.useMemo)(() => {
        const uniqueErrors = new Set(errors);
        const errorTypesMessage = Array.from(uniqueErrors).map((errorType) => t({ key: upload_data_dialog_constants_1.PARSE_ERROR_TYPE_TO_MESSAGE_KEY[errorType] })).join('\n');
        if (uniqueErrors.has(hooks_1.ErrorTypes.Parse)) {
            return errorTypesMessage;
        }
        const updateProductsMessage = t({ key: 'CSV_PARSE_ERROR_MESSAGE', values: { errorCount: errors.length, productCount: data.length + errors.length } });
        return (react_1.default.createElement(react_1.default.Fragment, null, updateProductsMessage, react_1.default.createElement("br", null), errorTypesMessage));
    }, [data.length, errors, t]);
    const proceedButtonDisabled = !fileToUpload || isFileUploading;
    return (react_1.default.createElement(upload_data_dialog_styles_1.StyledDialog, { open: true, proceedButtonProps: {
            title: t({ key: updateDataType === upload_file_options_1.UpdateCatalogTypes.CreateCatalog ? 'CREATE' : 'UPDATE' }),
            disabled: proceedButtonDisabled,
            endIcon: isFileUploading && react_1.default.createElement(generic_1.LoadingIndicator, null),
            onClick: handleSubmit,
        }, cancelButtonProps: {
            title: t({ key: 'CANCEL' }),
            onClick: onClose,
        }, title: t({ key: 'UPDATE_CATALOG_TITLE' }) }, react_1.default.createElement(generic_1.ActionDialogContainer, null, react_1.default.createElement(upload_data_dialog_styles_1.StyledDialogContent, null, react_1.default.createElement("div", { className: "options-row" }, react_1.default.createElement(update_catalog_option_1.UpdateCatalogOption, { title: t({ key: 'UPDATE_CATALOG_OPTION_CATALOG' }), text: t({ key: 'UPDATE_CATALOG_OPTION_CATALOG_HINT' }), isSelected: updateDataType === upload_file_options_1.UpdateCatalogTypes.Catalog, isDisabled: isDisabled, selectedMode: updateDataMode, modeOptions: modeOptions, onModeChange: handleOptionChange, onSelect: () => setUpdateDataType(upload_file_options_1.UpdateCatalogTypes.Catalog) }), react_1.default.createElement(update_catalog_option_1.UpdateCatalogOption, { title: t({ key: 'UPDATE_CATALOG_OPTION_ENRICHED_DATA' }), text: t({ key: 'UPDATE_CATALOG_OPTION_ENRICHED_DATA_HINT' }), isSelected: updateDataType === upload_file_options_1.UpdateCatalogTypes.Data, isDisabled: isDisabled, selectedMode: updateDataMode, modeOptions: modeOptions, onModeChange: handleOptionChange, onSelect: () => setUpdateDataType(upload_file_options_1.UpdateCatalogTypes.Data) }), isCreateCatalogEnabled && (react_1.default.createElement(update_catalog_option_1.UpdateCatalogOption, { title: t({ key: 'UPDATE_CATALOG_OPTION_CREATE_CATALOG' }), text: t({ key: 'UPDATE_CATALOG_OPTION_CREATE_CATALOG_HINT' }), isSelected: updateDataType === upload_file_options_1.UpdateCatalogTypes.CreateCatalog, onSelect: () => setUpdateDataType(upload_file_options_1.UpdateCatalogTypes.CreateCatalog) }))), react_1.default.createElement(upload_box_1.UploadBox, { id: "upload-file-input", fileType: '.csv', onChange: setFileToUpload }), fileUploadError && react_1.default.createElement(components_1.Alert, { severity: "error" }, fileUploadError), errors.length > 0 && (react_1.default.createElement(components_1.Alert, { severity: "error" }, errorMessage)), data.length > 0 && !errors.length && (react_1.default.createElement(components_1.Alert, { severity: "info" }, t({ key: 'CSV_PARSE_SUCCESS_MESSAGE', values: { productCount: data.length, uploadMode: t({ key: updateDataMode === upload_file_options_1.UpdateDataModes.Merge ? 'MERGE' : 'REPLACE' }) } })))))));
};
exports.UploadDataDialog = UploadDataDialog;
exports.default = exports.UploadDataDialog;
